const E = {
  NoResults:
    'We couldn’t find any jobs or samples that match your search criteria.',
  NoResultsBody:
    'Please double check your search criteria or try a broader search. If you need assistance, please contact your Bureau Veritas representative.',
  NoJobs: 'There are currently no jobs available.',
  NewJob1: "If you'd like to create a new job, please click",
  NewJob: 'New Job',
  Received: 'Received',
  'Draft & Submitted': 'Draft & Submitted',
  'Additional Analysis': 'Additional Analysis',
  BeingImported: 'This job is currently being imported.',
  MakeChanges:
    'To make changes, please contact your Bureau Veritas representative.',
  'eCOC Submission Summary': 'eCOC Submission Summary',
  'eCOC Submission Details': 'eCOC Submission Details',
  'Tracking Form': 'Tracking Form',
  'Add Test Draft & Submitted': 'Add Test Draft & Submitted',
  Samples: 'Samples',
  Jobs: 'Jobs',
  Job: 'Job',
  Order:'Order',
  Draft: 'Draft',
  Pending: 'Pending',
  Paid: 'Paid',
  Cancelled: 'Cancelled',
  Overridden: 'Overridden',
  ResendModelTitle: 'Resend Payment Request',
  ResendReceiptModelTitle: 'Resend Payment Receipt',
  ResendTitle:'Add an email address to the box and click the Plus sign.',
  Mail: 'Email',
  'Split Reports': "Split Reports"
};

const F = {
  NoResults:
    'Aucun dossier ni échantillon ne correspond à vos critères de recherche.',
  NoResultsBody:
    'Veuillez vérifier les critères de recherche ou les élargir. Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  NoJobs: 'Aucun dossier disponible pour le moment.',
  NewJob1: 'Pour créer un nouveau dossier, cliquez sur',
  NewJob: 'Nouveau dossier',
  Received: 'Reçu',
  'Draft & Submitted': 'Ébauche et envoi',
  'Additional Analysis': 'Analyse supplémentaire',
  'Add Test Draft & Submitted': 'Add Test Draft & Submitted',
  BeingImported: 'Ce dossier est en cours d’importation',
  MakeChanges:
    'Pour toute modification, veuillez contacter votre représentant des Lab BV.',
  'eCOC Submission Summary': 'eCDR Résumé de l’envoi ',
  'eCOC Submission Details': 'eCDR Détails de l’envoi',
  'Tracking Form': 'Formulaire de référence de suivi',
  Samples: 'Échantillons',
  Jobs: 'Dossiers',
  Job: 'Emploi',
  Order: 'Commande',
  Draft: 'Ébauche',
  Pending: 'En attente',
  Paid: 'Payé',
  Cancelled: 'Annulé',
  Overridden: 'Remplacé',
  ResendModelTitle: 'Renvoyer la demande de paiement',
  ResendReceiptModelTitle: 'Renvoyer le reçu de paiement',
  ResendTitle:'Ajoutez une adresse e-mail dans la case et cliquez sur le signe Plus.',
  Mail: 'E-mail',
  'Split Reports': "Rapports fractionnés",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/jobs.js